import user from './user.interface';

export const getFullName = (user: user, sortBy = 'firstName') => {
  if (!user.firstName && !user.lastName) return user.login;
  if (sortBy === 'lastName') return `${user?.lastName || ''} ${user?.firstName || ''}`.trim();
  return `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
};
